
// the save scatter graph Alpine object
window.appSaveScatterGraph = () => {
    return {
        status: false,
        init: function() {
            let stats = [];
            if(this.$store.inputs.current.position == ['GK']) {
                stats = [
                    this.$store.inputs.current.stat1IdGk,
                    this.$store.inputs.current.stat2IdGk,
                ]
            } else {
                stats = [
                    this.$store.inputs.current.stat1Id,
                    this.$store.inputs.current.stat2Id,
                ]
            }
            let path = [
                '/api/saved-scatter-graph',
                this.$store.inputs.current.leagueIds.join(','),
                this.$store.inputs.current.position.join(','),
                this.$store.inputs.current.season,
                ...stats,
                this.$store.inputs.current.dotSize,
                this.$store.inputs.current.foot,
                this.$store.inputs.current.age.min,
                this.$store.inputs.current.age.max,
                this.$store.inputs.current.minutesPlayed.min,
                this.$store.inputs.current.minutesPlayed.max,
                this.$store.inputs.current.value.min,
                this.$store.inputs.current.value.max,
                this.$store.inputs.current.contractLength.min,
                this.$store.inputs.current.contractLength.max,
                this.$store.inputs.current.gbeEligible,
                this.$store.inputs.current.gbePotential,
                this.$store.inputs.current.gbeIneligible,
                this.$store.inputs.current.euPassport,
                this.$store.inputs.current.internationalApps,
            ]

            axios.get(buildPath(path))
                .then( response => {
                    if( response.data == '1' ) {
                        this.status = 'saved';
                    } else {
                        this.status = 'default';
                    }
                })
                .catch( ajaxFail );
        },
        save: function() {
            if( this.status == 'saved') {
                return;
            }
            this.status = 'saving';

            let stats = [];
            if(this.$store.inputs.current.position == ['GK']) {
                stats = [
                    this.$store.inputs.current.stat1IdGk,
                    this.$store.inputs.current.stat2IdGk,
                ]
            } else {
                stats = [
                    this.$store.inputs.current.stat1Id,
                    this.$store.inputs.current.stat2Id,
                ]
            }
            let path = [
                '/api/save-scatter-graph',
                this.$store.inputs.current.leagueIds.join(','),
                this.$store.inputs.current.position.join(','),
                this.$store.inputs.current.season,
                ...stats,
                this.$store.inputs.current.dotSize,
                this.$store.inputs.current.foot,
                this.$store.inputs.current.age.min,
                this.$store.inputs.current.age.max,
                this.$store.inputs.current.minutesPlayed.min,
                this.$store.inputs.current.minutesPlayed.max,
                this.$store.inputs.current.value.min,
                this.$store.inputs.current.value.max,
                this.$store.inputs.current.contractLength.min,
                this.$store.inputs.current.contractLength.max,
                this.$store.inputs.current.gbeEligible,
                this.$store.inputs.current.gbePotential,
                this.$store.inputs.current.gbeIneligible,
                this.$store.inputs.current.euPassport,
                this.$store.inputs.current.internationalApps,
            ]

            axios.post(buildPath(path)).
                then( () => {
                    this.status = 'saved';
                    // setTimeout( () =>  this.status = 'default', 3000);
                })
                .catch( ajaxFail )
        }
    }
}
